import { useEffect, useState } from "react";
import content from "../../services/api-content";
import { getStoredProfile } from "../../services/apiClient";

let cache = { email: null, promise: null };

/** ข้อมูลผู้ใช้จาก GS (me.get) มี id จริงสำหรับเช็คความเป็นเจ้าของ — cache ตามอีเมล */
export const loadMe = (force) => {
  const email = getStoredProfile()?.email || "";
  if (force || cache.email !== email || !cache.promise) {
    cache = { email, promise: content.me.get().catch((e) => { cache = { email: null, promise: null }; throw e; }) };
  }
  return cache.promise;
};

export default function useMe() {
  const [me, setMe] = useState(null);
  useEffect(() => {
    let alive = true;
    loadMe().then((u) => alive && setMe(u)).catch(() => {});
    return () => { alive = false; };
  }, []);
  return me;
}
